import { useEffect, useState } from "react";

const mediaQueryList = (query) => {
  try {
    return typeof window !== "undefined" &&
      typeof window.matchMedia === "function"
      ? window.matchMedia(query)
      : null;
  } catch (e) {
    return null;
  }
};

// Whether a CSS media query matches, following the window as it resizes or
// rotates. False where matchMedia doesn't exist.
const useMatchMedia = (query) => {
  const [matches, setMatches] = useState(() => {
    const list = mediaQueryList(query);
    return Boolean(list && list.matches);
  });

  useEffect(() => {
    const list = mediaQueryList(query);
    if (!list) {
      setMatches(false);
      return undefined;
    }
    const onChange = () => setMatches(Boolean(list.matches));
    onChange();
    if (typeof list.addEventListener === "function") {
      list.addEventListener("change", onChange);
      return () => list.removeEventListener("change", onChange);
    }
    if (typeof list.addListener === "function") {
      list.addListener(onChange);
      return () => list.removeListener(onChange);
    }
    return undefined;
  }, [query]);

  return matches;
};

export default useMatchMedia;
